module.exports = __webpack_public_path__ + "static/media/bomb.a125cf3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/bomb/bomb.svg
// module id = 28
// module chunks = 0